import { Link } from 'react-router-dom';
import { getSession, clearSession } from '../api';

// The compact lockup (mark + SEND, no byline) rather than the full one: at the
// header's 36px the stacked byline renders around 7px and is unreadable. The
// "by intake.dental" attribution lives in the footer and the og card instead.
const LOGO = '/send-lockup-compact.svg';

export default function Header() {
  const session = getSession();

  // A full page load, not nav('/'): the upload page holds its signed-in step
  // in state, so a client-side route change back to / left the compose screen
  // (and this header's links) on screen after the token was gone.
  const signOut = () => {
    clearSession();
    window.location.assign('/');
  };

  return (
    <header className="site-header">
      <div className="inner">
        <Link to="/" className="brand" aria-label="SEND by Intake.Dental — secure file transfer">
          <img src={LOGO} alt="SEND by Intake.Dental" />
        </Link>
        <nav className="nav-links">
          <Link to="/how-it-works">How it works</Link>
          <Link to="/security">Security</Link>
          <Link to="/faq">FAQ</Link>
          {session?.token ? (
            <>
              <Link to="/dashboard">My Transfers</Link>
              {/* Same account: a Send session opens Store without a second sign-in. */}
              <a href="https://store.intake.dental/">Store</a>
              <a href="#" onClick={(e) => { e.preventDefault(); signOut(); }}>Sign out</a>
            </>
          ) : null}
        </nav>
      </div>
    </header>
  );
}
